import "./DeepAnalysis.module.css";
import NavigationBar from "@/reusable_sections/Header";
import TheTransformationProcess from "./sections/TheTransformationProcess";
import KeyStatistics from "./sections/KeyStatistics";
import FooterInformation from "@/reusable_sections/Footer";
export default function DeepAnalysisPage() {
  return <div>
      <NavigationBar />
      <TheTransformationProcess />
      <KeyStatistics />
      <FooterInformation />
    </div>;
}